import { render } from "./Editor.vue?vue&type=template&id=e8e00e22"
import script from "./Editor.vue?vue&type=script&lang=ts"
export * from "./Editor.vue?vue&type=script&lang=ts"

import "./Editor.vue?vue&type=style&index=0&id=e8e00e22&lang=scss"
script.render = render

export default script